import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import {
  Container,
  Card,
  CardBody,
  CardTitle,
  Form,
  Row,
  Col,
  Button,
  Input,
  Label,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Loader from "components/Common/Loader";

// Backend
import {
  getClientFullList,
  getSubproductTypeList,
  postSubproductCreate,
} from "connection/backend";
import { Link, useHistory } from "react-router-dom";

const SubproductRegister = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(false);
  const [alert1, setAlert1] = useState(false);
  const [clients, setClients] = useState([]);
  const [products, setProducts] = useState([]);
  const [formData, setFormData] = useState({
    client: "",
    product: "",
    payment_method: "efectivo",
    bank: "banco_1",
    total: 0,
  });

  const { client, product, payment_method, bank, total } = formData;

  const getClientData = async () => {
    const response = await getClientFullList();
    const data = response.data;
    setClients(data);
  };

  const getSubproductData = async () => {
    const response = await getSubproductTypeList();
    const data = response.data;
    setProducts(data);
  };

  const postSubproductData = async () => {
    try {
      setLoading(true);
      const subproduct = {
        client: client,
        product: product,
        payment_method: payment_method,
        bank: payment_method === "efectivo" ? "no_aplica" : bank,
        total: total,
      };
      const response = await postSubproductCreate(subproduct);
      if (response.status === 201) {
        setLoading(false);
        setAlert(true);
      } else {
        setLoading(false);
        setAlert1(true);
      }
    } catch (error) {
      setLoading(false);
      setAlert1(true);
      console.error("Error al registrar el subproducto", error);
    }
  };

  useEffect(() => {
    getClientData();
    getSubproductData();
  }, []);

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    postSubproductData();
  };

  const redirect = () => {
    history.push("/dashboard");
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Subproductos </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Subproductos"} />
          {loading ? (
            <Loader />
          ) : (
            <div className="d-flex justify-content-center">
              {alert ? (
                <SweetAlert
                  title="¡Hecho!"
                  success
                  showConfirm={true}
                  show={alert}
                  onConfirm={() => {
                    redirect();
                  }}
                >
                  La entrada se registró correctamente.
                </SweetAlert>
              ) : null}
              {alert1 ? (
                <SweetAlert
                  title="¡Error!"
                  danger
                  showConfirm={true}
                  show={alert1}
                  onConfirm={() => {
                    setAlert1(false);
                  }}
                >
                  Ocurrió un error al registrar la entrada, intente nuevamente.
                </SweetAlert>
              ) : null}
              <Card
                style={{
                  width: "70rem",
                }}
              >
                <CardTitle className="ps-3 pt-3">
                  <h2 className="mb-2 font-size-20">Registrar venta</h2>
                </CardTitle>
                <CardBody>
                  <Row className="justify-content-md-start">
                    <Col lg={6} className="mt-1">
                      <Link
                        className="btn btn-primary waves-effect waves-light"
                        to="/subproducts/create"
                      >
                        Agregar subproducto
                      </Link>
                    </Col>
                  </Row>
                  <Row className="justify-content-md-center mt-1 mb-1">
                    <Col lg={12}>
                      <hr />
                    </Col>
                  </Row>
                  <Form onSubmit={onSubmit}>
                    <Row className="justify-content-md-center mb-2">
                      <Col lg={5}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bxs-contact bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="select"
                              className="form-control"
                              placeholder="Cliente"
                              name="client"
                              id="client"
                              value={client}
                              onChange={onChange}
                              required
                            >
                              <option defaultValue value="">
                                -----
                              </option>
                              {clients.map((client, idx) => (
                                <option
                                  key={idx}
                                  value={client.code}
                                >{`${client.code} - ${client.full_name}`}</option>
                              ))}
                            </Input>
                            <Label for="client">Cliente</Label>
                          </div>
                        </div>
                      </Col>
                      <Col lg={5}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-receipt bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="select"
                              className="form-control"
                              placeholder="Subproducto"
                              name="product"
                              id="product"
                              value={product}
                              onChange={onChange}
                              required
                            >
                              <option defaultValue value="">
                                -----
                              </option>
                              {products.map((product, idx) => (
                                <option key={idx} value={product.id}>
                                  {product.name}
                                </option>
                              ))}
                            </Input>
                            <Label for="product">Subproducto</Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center mb-4">
                      <Col lg={5}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-credit-card bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="select"
                              className="form-control"
                              placeholder="Método de pago"
                              name="payment_method"
                              id="payment_method"
                              value={payment_method}
                              onChange={onChange}
                              required
                            >
                              <option defaultValue value="efectivo">
                                Efectivo
                              </option>
                              <option defaultValue value="consignacion">
                                Consignación
                              </option>
                            </Input>
                            <Label for="payment_method">Método de pago</Label>
                          </div>
                        </div>
                      </Col>
                      {payment_method === "consignacion" ? (
                        <Col lg={5}>
                          <div className="input-group mb-3">
                            <span className="input-group-text">
                              <i className="bx bxs-bank bx-sm" />
                            </span>
                            <div className="form-floating">
                              <Input
                                type="select"
                                className="form-control"
                                placeholder="Banco"
                                name="bank"
                                id="bank"
                                value={bank}
                                onChange={onChange}
                                required
                              >
                                <option defaultValue value="banco_1">
                                  Banco de Bogotá
                                </option>
                                <option defaultValue value="banco_2">
                                  Bancolombia
                                </option>
                              </Input>
                              <Label for="bank">Banco</Label>
                            </div>
                          </div>
                        </Col>
                      ) : null}
                      <Col lg={5}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-dollar bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="number"
                              className="form-control"
                              placeholder="Total"
                              name="total"
                              id="total"
                              value={total}
                              min={0}
                              onChange={onChange}
                              required
                            />
                            <Label for="total">Total</Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center mt-0 ms-5">
                      <Col lg={3}>
                        <Link className="btn btn-danger me-4" to="/dashboard">
                          Volver
                        </Link>

                        <Button color="success" type="submit">
                          Registrar
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SubproductRegister;
